import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { isApiResponse } from 'modules/api/utils';
import { handleQueryError } from 'store/utils';

import { openNatterApi } from './openNatterApi';

import type { RootState } from 'store';

export const openNatterApiListener = createListenerMiddleware<RootState>();

openNatterApiListener.startListening({
  matcher: isAnyOf(
    openNatterApi.endpoints.postReady.matchRejected,
    openNatterApi.endpoints.postLeave.matchRejected,
    openNatterApi.endpoints.postRating.matchRejected,
    openNatterApi.endpoints.postAnswers.matchRejected
  ),
  effect: ({ type, payload }, { dispatch }) => {
    const response = isApiResponse(payload) ? payload : undefined;

    handleQueryError(payload, dispatch, type, (response?.data as string) || 'Unable to call Open Natter API');
  },
});
